import { ClientError } from 'graphql-request';

/**
 * The API prefixes validation messages with the record it rejected, e.g.
 * "[Event 224] Calendar settings are required..." or "[Event Session 224] ...".
 * Useful in logs, noise in a toast.
 */
const RECORD_PREFIX = /^\[[^\]]+\]\s*/;

/**
 * Pulls the API's own reason out of a failed GraphQL request so it can be shown instead
 * of a generic "please try again later" — those messages are already written for admins
 * and name the setting to fix. Falls back to `fallback` for transport-level failures,
 * where there is no server-authored reason to show.
 */
export const getGraphQLErrorMessage = (error: unknown, fallback: string): string => {
  if (!(error instanceof ClientError)) return fallback;

  const message = error.response?.errors?.[0]?.message?.trim();
  if (!message) return fallback;

  return message.replace(RECORD_PREFIX, '') || fallback;
};
